import { useGoogleAnalyticsContext } from "contexts/GoogleAnalyticsProvider";
import { useWebStoreContext } from "contexts/WebStoreProvider";
import { useAppSelector } from "hooks";
import { useLinks } from "hooks/useLinks";
import { SaleTag } from "interfaces";
import { useLocation, matchPath } from "react-router-dom";
import { selectStickySaleTagState } from "redux/slices";
import { getStickiesFromLocalStorage } from "redux/slices/sticky-sale-tag/helper";
import { isStickyTagVisibleOnRoute } from "../helpers/isStickyTagVisibleOnRoute";

export const useGetStickyTag = (): SaleTag | undefined => {
	const { pathname } = useLocation();
	const { nowTime, authToken } = useWebStoreContext();
	const LS_STICKIES = getStickiesFromLocalStorage() ?? [];
	const { reportEvent, reportPlaygamiEvent } = useGoogleAnalyticsContext();
	const state = useAppSelector(selectStickySaleTagState);
	const saleTags = state?.saleTags ?? [];
	const closedStickyTags = state?.closedStickyTags ?? [];
	const links = useLinks();

	// Don't show sticky tag if user is not authenticated
	if (!authToken?.value) {
		return;
	}

	// @ts-expect-error
	const notTimeReady = typeof nowTime._tzm === "undefined";
	if (notTimeReady) {
		return;
	}

	const linkTitle = Object.values(links).find(
		(link) =>
			!link?.isExternal &&
			matchPath({ path: link.path, end: link.path === "/" }, pathname)
	)?.title;

	const stickyTags = saleTags.filter((tag) =>
		isStickyTagVisibleOnRoute({ tag, pathname, linkTitle, links })
	);
	const stickyTag = stickyTags.find((tag) => {
		//if (nowTime?.isAfter(tag.startTime) && nowTime.isBefore(tag.endTime)) {
		return tag;
		//}
	});
	const foundOnStorage = LS_STICKIES.find(
		(stickyStoraged) => stickyStoraged.id === stickyTag?.id
	);

	// prettier-ignore
	if (
		typeof stickyTag === "undefined" ||
		!stickyTag.showStickyTag ||
		closedStickyTags.includes(stickyTag.id) ||
		typeof foundOnStorage !== "undefined"
	) { return; }

	const { priority, stickyTagText } = stickyTag;

	reportEvent("spawn_sticky_tag", {
		source: "sticky_tag",
		//sale_start_time: startTime,
		//sale_end_time: endTime,
		priority,
		stickyTagText: stickyTagText
	});
	reportPlaygamiEvent("tp.web_frontend", {
		event_name: "spawn_sticky_tag",
		event_type: "sticky_tag",
		source: "sticky_tag",
		action: "spawn_sticky_tag",
		//time_total: moment(endTime).diff(startTime, "seconds"),
		priority,
		tag_text: stickyTagText
	});

	return stickyTag;
};
